import { render, staticRenderFns } from "./RecordDeleteItem.vue?vue&type=template&id=16a9c7e2&"
import script from "./RecordDeleteItem.vue?vue&type=script&lang=js&"
export * from "./RecordDeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports